const generateMagazineDetailUrl = (magazineId: string): string =>
	`/magazine/${encodeURIComponent(magazineId)}`;

const generateTypeformUrl = (typeformId: string, achievement: string): string =>
	`https://gruppofood.typeform.com/to/${typeformId}?achievement=${achievement}`;

const generateLocalTypeformUrl = (
	typeformId: string,
	redirect: string,
	fallback: string,
): string =>
	`/forms/${typeformId}?redirect=${encodeURIComponent(
		redirect,
	)}&fallback=${encodeURIComponent(fallback)}`;

const generateMagazineReadUrl = (magazineId: string): string =>
	generateMagazineDetailUrl(magazineId) + '/read';

const generateMagazinePreviewUrl = (magazineId: string): string =>
	generateMagazineDetailUrl(magazineId) + '/preview';

export {
	generateMagazineDetailUrl,
	generateMagazineReadUrl,
	generateMagazinePreviewUrl,
	generateTypeformUrl,
	generateLocalTypeformUrl,
};
